import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Area from '../../../../../../common/chart/chartContainer/Area'
import Bar from '../../../../../../common/chart/chartContainer/Bar'
import { Legend } from '../../../../../../common/chart/legend'
import { getUnique } from '../../../../../../helpers/common'
import { formatVal } from '../../../../../../helpers/value'
import { selectUserType } from '../../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../../utils/authorization'
import { getValueAndTitleCheckbox } from '../../../helper'
import { changeChecked, selectChecked } from '../../../store/slice'
import { TREND_BOTTOM_CHART } from '../constant'
import { selectDataViewByTrend, selectIndicatorById } from '../store/slice'

const BottomChart = ({ id, check, isDynamicReport }) => {
  const chartId = useRef(getUnique())

  const dispatch = useDispatch()

  const userType = useSelector(selectUserType)
  const locale = useSelector((state) => state.i18n.locale)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const checkboxs = TREND_BOTTOM_CHART.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))

  const handleSetChecked = (checked) => {
    if (checkboxs.some((checkbox) => checked.includes(checkbox.value))) {
      dispatch(changeChecked({ id, checked }))
    }
  }

  const bars = checkboxs.filter(
    (item) => item.isBarChart && checked.includes(item.value),
  )

  const areas = checkboxs.filter(
    (item) => item.isAreaChart && checked.includes(item.value),
  )

  return (
    <div className="flexColumn flex1 minH0">
      <div className="dFlex h100">
        <ChartContainer
          chartId={chartId.current}
          data={dataByTrend}
          margin={{
            top: 10,
            bottom: 0,
            left: isDynamicReport ? 16 : 0,
            right: !bars.length ? 16 : 0,
          }}
          width={'60%'}
          height={'100%'}
          xAxis={[{ dataKey: 'year', height: 30 }]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: checkboxs.map((item) => item.value),
              isBarChart: true,
            },
          ]}
          tooltip={{
            schema: {
              content: [
                ...areas.map((area) => ({
                  dataKey: area.value,
                  label: area.title,
                  formatValue: (value) => formatVal(value, locale),
                })),
                ...bars.map((bar) => ({
                  dataKey: bar.value,
                  label: bar.title,
                  formatValue: (value) => formatVal(value, locale),
                })),
              ],
            },
          }}
        >
          {areas.map((area) => (
            <Area
              key={area.value}
              yAxisId={'left'}
              dataKey={area.value}
              fill={area.color}
              dot={{ fill: area.dotColor }}
            />
          ))}
          {bars.map((bar) => (
            <Bar
              key={bar.value}
              yAxisId="left"
              dataKey={bar.value}
              fill={bar.color}
              maxBarSize={25}
            />
          ))}
        </ChartContainer>
        <div className="h100 w40 px1 py1 dFlex alignItemsCenter">
          <Legend
            chartId={chartId.current}
            items={checkboxs.map((item) => ({
              title: item.title,
              isI18n: false,
              value: item.value,
              dataKey: item.value,
              color: item.color,
              isCheckbox: userType?.userTypeId === USER_TYPE.PREMIUM,
              listCheckBox: checked,
              setListCheckBox: handleSetChecked,
              isDynamicReport: isDynamicReport,
            }))}
            className="flexColumn"
            style={{ gap: '4px' }}
          />
        </div>
      </div>
    </div>
  )
}

export default BottomChart
